(function () {
  // ===== PRODUCT VARIANT IDs =====
  const REMOTE_VARIANT_IDS = [
    '51736231739712', // Yellow
    '51736231772480', // Blue
    '51736231805248'  // Pink
  ];
  const PENCIL_TIPS_VARIANT_ID = '51959272374592';

  // Product photos used inside the upsell popup
  const REMOTE_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0980/7387/0656/files/WhatsApp_Image_2026-04-04_at_12.44.54.jpg?v=1775303034';
  const PENCIL_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0980/7387/0656/files/WhatsApp_Image_2026-05-04_at_17.22.39.jpg?v=1777923151';
  
  let bodyLockState = null;
  let lastFocusedElement = null;
  let responsiveFrame = 0;
  let layoutResizeObserver = null;
  let cartHeaderInitialized = false;

  function formatMoney(amount) {
    return `${Number(amount).toFixed(2)} USD`;
  }

  function getViewportHeight() {
    const visualViewportHeight = window.visualViewport && Number(window.visualViewport.height);
    const fallbackHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const viewportHeight = visualViewportHeight > 0 ? visualViewportHeight : fallbackHeight;
    return Math.max(1, Math.round(viewportHeight));
  }

  function updateResponsiveMeasurements() {
    responsiveFrame = 0;

    const announcement = document.getElementById('announcementBar');
    const header = document.querySelector('.studymote-header');
    const announcementHeight = announcement ? announcement.getBoundingClientRect().height : 40;
    const headerHeight = header ? header.getBoundingClientRect().height : 80;
    const root = document.documentElement;

    root.style.setProperty('--announcement-h', `${Math.max(0, Math.ceil(announcementHeight))}px`);
    root.style.setProperty('--header-h', `${Math.max(0, Math.ceil(headerHeight))}px`);
    root.style.setProperty('--studymote-viewport-height', `${getViewportHeight()}px`);
  }

  function scheduleResponsiveMeasurements() {
    if (responsiveFrame) {
      window.cancelAnimationFrame(responsiveFrame);
    }

    responsiveFrame = window.requestAnimationFrame(updateResponsiveMeasurements);
  }

  function setElementAttribute(element, name, value) {
    if (element) {
      element.setAttribute(name, value);
    }
  }

  function closeMobileMenu() {
    const mobileMenu = document.getElementById('mobileMenu');
    const toggle = document.querySelector('.mobile-menu-toggle');

    if (mobileMenu) mobileMenu.classList.remove('active');
    if (toggle) {
      toggle.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function lockPageScroll() {
    if (bodyLockState || !document.body) return;

    const body = document.body;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const computedPaddingRight = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

    bodyLockState = {
      scrollY: scrollY,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };

    document.documentElement.classList.add('studymote-cart-open');
    body.classList.add('studymote-cart-open');
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${computedPaddingRight + scrollbarWidth}px`;
    }
  }

  function unlockPageScroll() {
    const body = document.body;
    const state = bodyLockState;

    document.documentElement.classList.remove('studymote-cart-open');
    if (body) body.classList.remove('studymote-cart-open');

    if (!body || !state) {
      bodyLockState = null;
      return;
    }

    body.style.position = state.position;
    body.style.top = state.top;
    body.style.left = state.left;
    body.style.right = state.right;
    body.style.width = state.width;
    body.style.overflow = state.overflow;
    body.style.paddingRight = state.paddingRight;
    bodyLockState = null;

    window.requestAnimationFrame(function () {
      window.scrollTo(0, state.scrollY);
    });
  }

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0;
    });
  }

  function handleDrawerKeydown(event) {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer || !drawer.classList.contains('active')) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeCartDrawer();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements(drawer);
    if (!focusable.length) {
      event.preventDefault();
      drawer.focus({ preventScroll: true });
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  async function openCartDrawer(cartOverride) {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    const cartButton = document.getElementById('cartButton');

    if (!drawer || !overlay) {
      return cartOverride || fetchCart();
    }

    const content = document.getElementById('cartDrawerContent');
    if (content) content.setAttribute('aria-busy', 'true');

    const cart = cartOverride || await fetchCart();
    renderCart(cart);

    if (content) content.setAttribute('aria-busy', 'false');

    closeMobileMenu();
    scheduleResponsiveMeasurements();

    if (!drawer.classList.contains('active')) {
      lastFocusedElement = document.activeElement;
    }

    drawer.classList.add('active');
    overlay.classList.add('active');
    setElementAttribute(drawer, 'aria-hidden', 'false');
    setElementAttribute(overlay, 'aria-hidden', 'false');
    setElementAttribute(cartButton, 'aria-expanded', 'true');
    lockPageScroll();

    window.requestAnimationFrame(function () {
      const closeButton = document.getElementById('closeCart');
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      } else {
        drawer.focus({ preventScroll: true });
      }
    });

    return cart;
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    const cartButton = document.getElementById('cartButton');

    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    setElementAttribute(drawer, 'aria-hidden', 'true');
    setElementAttribute(overlay, 'aria-hidden', 'true');
    setElementAttribute(cartButton, 'aria-expanded', 'false');
    unlockPageScroll();

    const focusTarget = lastFocusedElement;
    lastFocusedElement = null;

    if (focusTarget && document.contains(focusTarget) && typeof focusTarget.focus === 'function') {
      window.requestAnimationFrame(function () {
        focusTarget.focus({ preventScroll: true });
      });
    }
  }

  function toggleMobileMenu() {
    const mobileMenu = document.getElementById('mobileMenu');
    const toggle = document.querySelector('.mobile-menu-toggle');
    if (!mobileMenu || !toggle) return;

    const willOpen = !mobileMenu.classList.contains('active');
    if (willOpen) closeCartDrawer();

    mobileMenu.classList.toggle('active', willOpen);
    toggle.classList.toggle('active', willOpen);
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }
  
  function updateFreeShippingBar(cartTotal) {
    const freeThreshold = 60;
    const progressBar = document.getElementById('freeShippingProgress');
    const freeText = document.getElementById('freeShippingText');
    
    if (cartTotal >= freeThreshold) {
      if (freeText) freeText.innerHTML = '🎉 You qualify for FREE delivery! 🎉';
      if (progressBar) {
        progressBar.style.width = '100%';
        progressBar.style.background = '#FFD966';
      }
    } else {
      const remaining = (freeThreshold - cartTotal).toFixed(2);
      const percent = (cartTotal / freeThreshold) * 100;
      if (freeText) freeText.innerHTML = `✨ Add $${remaining} more for FREE delivery ✨`;
      if (progressBar) {
        progressBar.style.width = percent + '%';
        progressBar.style.background = '#82A0BC';
      }
    }
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) throw new Error('Failed to fetch cart');
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return { items: [], item_count: 0, total_price: 0 };
    }
  }

  // Add to cart - DOES NOT auto-open drawer
  async function addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!response.ok) throw new Error('Failed to add to cart');
      
      // Just update the cart count, don't open drawer
      const cart = await fetchCart();
      updateCartCount(cart);
      
      return cart;
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Could not add item to cart. Please try again.');
      return null;
    }
  }

  async function changeCartItem(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!response.ok) throw new Error('Failed to update cart item');
      
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      console.error('Error updating cart:', error);
      alert('Could not update the cart. Please try again.');
      return null;
    }
  }

  function updateCartCount(cart) {
    const totalQty = cart?.item_count || 0;
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = totalQty;
    });
  }
  
  function hasRemoteInCart(cart) {
    if (!cart.items || cart.items.length === 0) return false;
    return cart.items.some(item => REMOTE_VARIANT_IDS.includes(String(item.variant_id)));
  }
  
  function hasPencilInCart(cart) {
    if (!cart.items || cart.items.length === 0) return false;
    return cart.items.some(item => String(item.variant_id) === String(PENCIL_TIPS_VARIANT_ID));
  }
  
  function getItemImage(item) {
    if (item.image) return item.image;
    if (item.featured_image) return item.featured_image.url;
    return '';
  }
  
  function renderSuggestionPopup(cart) {
    const hasRemote = hasRemoteInCart(cart);
    const hasPencil = hasPencilInCart(cart);
    const itemCount = cart.items?.length || 0;
    
    console.log('Checking popup - hasRemote:', hasRemote, 'hasPencil:', hasPencil, 'itemCount:', itemCount);
    
    // Only show if one product type is in cart (not both)
    if (itemCount > 0 && !(hasRemote && hasPencil)) {
      if (hasRemote && !hasPencil) {
        console.log('✅ Showing Pencil suggestion');
        const div = document.createElement('div');
        div.className = 'cart-suggestion-popup';
        div.innerHTML = `
          <div class="suggestion-product-row">
            <img class="suggestion-product-image" src="${PENCIL_IMAGE_URL}" alt="StudyMote Apple Pencil Tips" width="72" height="72" loading="lazy" decoding="async">
            <div class="suggestion-product-copy">
              <h4>✏️ Add a apple pencil tips for $15</h4>
              <p>and get free delivery</p>
              <div class="suggestion-buttons">
                <button class="suggestion-btn suggestion-btn-primary" type="button" data-add-pencil>➕ Add apple pencil tips — $15</button>
                <button class="suggestion-btn suggestion-btn-secondary" type="button" data-dismiss-suggestion>No, thanks</button>
              </div>
            </div>
          </div>
        `;
        return div;
      } 
      else if (hasPencil && !hasRemote) {
        console.log('✅ Showing Remote suggestion');
        const div = document.createElement('div');
        div.className = 'cart-suggestion-popup';
        div.innerHTML = `
          <div class="suggestion-product-row">
            <img class="suggestion-product-image" src="${REMOTE_IMAGE_URL}" alt="StudyMote Remote" width="72" height="72" loading="lazy" decoding="async">
            <div class="suggestion-product-copy">
              <h4>🎮 Add a remote for $36.77</h4>
              <p>and get free delivery</p>
              <div class="suggestion-buttons">
                <button class="suggestion-btn suggestion-btn-primary" type="button" data-add-remote>➕ Add Remote $36.77</button>
                <button class="suggestion-btn suggestion-btn-secondary" type="button" data-dismiss-suggestion>No, thanks</button>
              </div>
            </div>
          </div>
        `;
        return div;
      }
    }
    return null;
  }

  function renderCart(cart) {
    const container = document.getElementById('cartDrawerContent');
    const checkoutBtn = document.getElementById('checkoutButton');
    const totalSpan = document.getElementById('cartTotal');

    if (!container) return;

    updateCartCount(cart);
    updateFreeShippingBar(cart.total_price / 100);

    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = `<div class="cart-empty-message"><p>Your cart is empty</p><p><small>Add the Remote or Pencil Tips to get started!</small></p></div>`;
      if (checkoutBtn) checkoutBtn.disabled = true;
      if (totalSpan) totalSpan.textContent = '0.00 USD';
      return;
    }

    container.innerHTML = '';

    cart.items.forEach(function (item, index) {
      const itemEl = document.createElement('div');
      itemEl.className = 'cart-item';
      const itemImage = getItemImage(item);
      
      const displayTitle = item.product_title || item.title || 'StudyMote product';
      const safeDisplayTitle = escapeHtml(displayTitle);
      const safeImageUrl = escapeHtml(itemImage);
      const showVariant = item.variant_title && item.variant_title !== 'Default Title';

      itemEl.innerHTML = `
        <div class="cart-item-layout">
          ${itemImage ? `<img class="cart-item-image" src="${safeImageUrl}" alt="${safeDisplayTitle}" width="60" height="60" loading="lazy" decoding="async">` : ''}
          <div class="cart-item-body">
            <div class="cart-item-heading-row">
              <div class="cart-item-copy">
                <div class="cart-item-title">${safeDisplayTitle}</div>
                ${showVariant ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
                <div class="cart-item-price">$${(item.final_price / 100).toFixed(2)} USD</div>
              </div>
              <button class="trash-icon" type="button" data-remove-line="${index + 1}" aria-label="Remove ${safeDisplayTitle}">🗑️</button>
            </div>
            <div class="quantity-controls" aria-label="Quantity controls for ${safeDisplayTitle}">
              <button class="quantity-btn" type="button" data-line="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span class="quantity-display" aria-live="polite">${item.quantity}</span>
              <button class="quantity-btn" type="button" data-line="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <div class="cart-item-line-total">Item total: $${(item.final_line_price / 100).toFixed(2)}</div>
          </div>
        </div>
      `;
      container.appendChild(itemEl);
    });
    
    // Add suggestion popup
    const popup = renderSuggestionPopup(cart);
    if (popup) {
      container.appendChild(popup);
      
      const addRemoteBtn = container.querySelector('[data-add-remote]');
      const addPencilBtn = container.querySelector('[data-add-pencil]');
      const dismissBtn = container.querySelector('[data-dismiss-suggestion]');
      
      if (addRemoteBtn) {
        addRemoteBtn.addEventListener('click', async () => {
          await addToCart(REMOTE_VARIANT_IDS[0], 1);
          // Refresh cart after adding
          const freshCart = await fetchCart();
          renderCart(freshCart);
        });
      }
      if (addPencilBtn) {
        addPencilBtn.addEventListener('click', async () => {
          await addToCart(PENCIL_TIPS_VARIANT_ID, 1);
          const freshCart = await fetchCart();
          renderCart(freshCart);
        });
      }
      if (dismissBtn) {
        dismissBtn.addEventListener('click', () => {
          popup.remove();
        });
      }
    }

    container.querySelectorAll('[data-line][data-qty]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = Number(btn.getAttribute('data-line'));
        const qty = Number(btn.getAttribute('data-qty'));
        if (qty >= 0) await changeCartItem(line, qty);
      });
    });

    container.querySelectorAll('[data-remove-line]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const line = Number(btn.getAttribute('data-remove-line'));
        await changeCartItem(line, 0);
      });
    });

    if (checkoutBtn) checkoutBtn.disabled = false;
    if (totalSpan) totalSpan.textContent = formatMoney(cart.total_price / 100);
  }
  
  function escapeHtml(str) {
    if (str === null || str === undefined) return '';

    return String(str).replace(/[&<>"']/g, function(m) {
      if (m === '&') return '&amp;';
      if (m === '<') return '&lt;';
      if (m === '>') return '&gt;';
      if (m === '"') return '&quot;';
      if (m === "'") return '&#039;';
      return m;
    });
  }

  async function refreshAndOpenCart() {
    try {
      return await openCartDrawer();
    } catch (error) {
      console.error('Error refreshing cart:', error);
      return null;
    }
  }

  // ===== CHECKOUT =====
  let isCheckingOut = false;
  
  async function proceedCheckout() {
    if (isCheckingOut) return;
    const checkoutBtn = document.getElementById('checkoutButton');
    try {
      isCheckingOut = true;
      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.textContent = '⏳ Processing...';
      }
      const cart = await fetchCart();
      if (!cart.items || cart.items.length === 0) {
        alert('Your cart is empty.');
        if (checkoutBtn) {
          checkoutBtn.disabled = true;
          checkoutBtn.textContent = 'Checkout';
        }
        return;
      }
      window.location.href = '/checkout';
    } catch (error) {
      alert('Unable to proceed to checkout.');
      if (checkoutBtn) {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Checkout';
      }
    } finally {
      isCheckingOut = false;
    }
  }

  // ===== INITIALIZATION =====
  async function initializeStudyMoteHeaderCart() {
    if (cartHeaderInitialized) return;
    cartHeaderInitialized = true;

    console.log('Cart initialized');
    updateResponsiveMeasurements();

    const cart = await fetchCart();
    renderCart(cart);

    const cartButton = document.getElementById('cartButton');
    if (cartButton) {
      cartButton.addEventListener('click', function(e) {
        e.preventDefault();
        refreshAndOpenCart();
      });
    }

    const closeCart = document.getElementById('closeCart');
    const cartOverlay = document.getElementById('cartOverlay');
    if (closeCart) closeCart.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

    const checkoutBtn = document.getElementById('checkoutButton');
    if (checkoutBtn) {
      const newCheckoutBtn = checkoutBtn.cloneNode(true);
      checkoutBtn.parentNode.replaceChild(newCheckoutBtn, checkoutBtn);
      newCheckoutBtn.addEventListener('click', proceedCheckout);
    }

    const mobileToggle = document.querySelector('.mobile-menu-toggle');
    if (mobileToggle) mobileToggle.addEventListener('click', toggleMobileMenu);

    document.querySelectorAll('.mobile-nav a').forEach(function(link) {
      link.addEventListener('click', closeMobileMenu);
    });

    document.addEventListener('keydown', handleDrawerKeydown);
    window.addEventListener('resize', scheduleResponsiveMeasurements, { passive: true });
    window.addEventListener('orientationchange', function() {
      scheduleResponsiveMeasurements();
      window.setTimeout(scheduleResponsiveMeasurements, 120);
      window.setTimeout(scheduleResponsiveMeasurements, 350);
    }, { passive: true });
    window.addEventListener('pageshow', scheduleResponsiveMeasurements, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleResponsiveMeasurements, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleResponsiveMeasurements, { passive: true });
    }

    if ('ResizeObserver' in window) {
      layoutResizeObserver = new ResizeObserver(scheduleResponsiveMeasurements);
      const announcement = document.getElementById('announcementBar');
      const header = document.querySelector('.studymote-header');
      if (announcement) layoutResizeObserver.observe(announcement);
      if (header) layoutResizeObserver.observe(header);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleResponsiveMeasurements).catch(function() {});
    }

    scheduleResponsiveMeasurements();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStudyMoteHeaderCart, { once: true });
  } else {
    initializeStudyMoteHeaderCart();
  }

  document.addEventListener('cart:updated', async function () {
    const cart = await fetchCart();
    renderCart(cart);
    scheduleResponsiveMeasurements();
  });

  document.addEventListener('cart:refresh', async function () {
    const cart = await fetchCart();
    renderCart(cart);
    scheduleResponsiveMeasurements();
  });

  document.addEventListener('product:added', async function () {
    await openCartDrawer();
  });

  window.studymoteAddToCart = addToCart;
  window.studymoteRefreshCart = refreshAndOpenCart;
  window.studymoteOpenCart = openCartDrawer;
})();